import React, { useState, useEffect } from "react";

const InfoSection = ({ categoryDetailes }) => {
  const categories = categoryDetailes?.parentDetails || [];

  const [selectedCategory, setSelectedCategory] = useState(null);

  // Set default category when data is available
  useEffect(() => {
    if (categories.length > 0) {
      setSelectedCategory(categories[0]);
    }
  }, [categories]);

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
  };

  if (!selectedCategory) {
    return <p>Loading categories...</p>;
  }

  return (
    <div className="container my-5">
      {/* Category Tabs */}
      <div className="d-flex flex-column flex-md-row justify-content-center mb-4">
        {categories.map((category) => (
          <button
            key={category.id}
            className={`btn btn-green-theme mx-2 mb-2 ${
              selectedCategory.id === category.id ? "active" : ""
            }`}
            onClick={() => handleCategoryClick(category)}
          >
            {category.name}
          </button>
        ))}
      </div>

      {/* Content Section */}
      <div className="row align-items-center">
        {/* Left Content */}
        <div className="col-md-6 order-2 order-md-1">
          <h3 className="mb-3">{selectedCategory.name}</h3>
          <div
            style={{ whiteSpace: "pre-line" }}
            dangerouslySetInnerHTML={{
              __html:
                selectedCategory.description ||
                "<p>No description available.</p>",
            }}
          />
        </div>

        {/* Right Image */}
        <div className="col-md-6 text-center order-1 order-md-2">
          <img
            src={selectedCategory?.image?.original}
            alt={selectedCategory?.name}
            className="img-fluid rounded shadow-sm mb-3"
          />
        </div>
      </div>
    </div>
  );
};

export default InfoSection;
